import BaseComponent from "../../../../utility/BaseComponent";
import { AsyncOperationsModel } from "../../../../utility/AsyncOperationsModel";
import { IResultsAnalytics } from "../../../../utility/admin/UsersControls/UsersAnalytics/IResultsAnalytics";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { AreaChart } from "react-easy-chart";
import "./static/ResultsAnalyticsView.scss";
import * as React from "react";
import * as moment from 'moment';

export class ResultsAnalyticsViewModel extends AsyncOperationsModel {
    @observable analytics: IResultsAnalytics;

    constructor(analytics: IResultsAnalytics) {
        super();
        this.analytics = analytics;
    }
    
}

@observer class ResultsAnalyticsView extends BaseComponent< {model: ResultsAnalyticsViewModel}, {} > {
    render() {
        let chartData: Array<{x: string, y: number}> = [];
        this.props.model.analytics.getSubmissionCountOverTime().forEach(
            (value, key) => {
                chartData.push({
                    x: key,
                    y: value
                });
            }
        );
        return(
            <section className='ResultsAnalyticsViewContainer'>
                <div className='ResultsContainer ResultsContainerGeneral'>
                    <div className='ResultsCard ResultsFocus'>
                        <div className='ResultsTotalSubmitted'>
                            <h4>Total Submitted</h4>
                            <h1>{this.props.model.analytics.results.length}</h1>
                        </div>
                        <div className='ResultsAverageSubmissionsPerDay'>
                            <h4>Avg. submissions per day</h4>
                            <h1>{this.props.model.analytics.getAvgSubmissionsPerDay()}</h1>
                        </div>
                    </div>
                    <div className='ResultsCardContainer'>
                        <div className='ResultsCard ResultsAverageScore'>
                            <h4>Average score</h4>
                            <h1>{this.props.model.analytics.getAvgScore()}</h1>
                        </div>
                        <div className='ResultsCard ResultsHighestScore'>
                            <h4>Highest score</h4>
                            <h1>{this.props.model.analytics.getHighestScore()}</h1>
                        </div>
                        <div className='ResultsCard ResultsLowestScore'>
                            <h4>Lowest score</h4>
                            <h1>{this.props.model.analytics.getLowestScore()}</h1>
                        </div>  
                    </div>
                </div>

                <div className='ResultsContainer ResultsContainerDetails'>
                    <div className='ResultsLineGraphContainer'>
                        <h4> Activity </h4>
                        <AreaChart 
                            className="ResultsLineGraph"
                            xType={"text"}
                            data={[
                                chartData                            
                            ]}
                            areaColors={['#415D78']}
                            width={400}
                            height={185}
                        />
                    </div>
                    <div className="PerDayDataContainer">
                        <div className="PerDayData">
                            <h4>Most submissions in one day</h4>
                            <h1>
                                {this.props.model.analytics.getMostSubmissionsInADay().count}
                                <span>
                                    {moment(this.props.model.analytics.getMostSubmissionsInADay().day)
                                    .toDate()
                                    .toDateString()}
                                </span>
                            </h1>
                        </div>
                        <div className="PerDayData">
                            <h4>Fewest submissions in one day</h4>
                            <h1>
                                {this.props.model.analytics.getLeastSubmissionsInADay().count}
                                <span>
                                    {moment(this.props.model.analytics.getLeastSubmissionsInADay().day)
                                    .toDate()
                                    .toDateString()}
                                </span>
                            </h1>
                        </div>
                    </div>
                </div>

            </section>
        );
    }
}

export default ResultsAnalyticsView;


// WEBPACK FOOTER //
// ./src/view/Admin/ResultsView/ResultsAnalyticsView/ResultsAnalyticsView.tsx